import React from 'react';
import PropTypes from 'prop-types';

/**
 * Base class for course content handlers
 * Each content type (PDF, YouTube, etc.) should extend this class
 * and implement required methods
 */
class BaseCourseContent extends React.Component {
    /**
     * Checks if this handler can handle given content
     * @param {string} url - Content URL to check
     * @returns {boolean} - True if this handler can handle the content
     */
    static canHandle(url) {
        throw new Error('canHandle must be implemented by child class');
    }

    /**
     * Renders the content
     * Each implementation should handle its specific content type
     */
    render() {
        return null;
    }
}

BaseCourseContent.propTypes = {
    content: PropTypes.shape({
        url: PropTypes.string.isRequired
    }).isRequired,
    onExamStart: PropTypes.func.isRequired,
    // False when another material still follows this one (button reads "Next"
    // instead of "Start exam"). Optional — defaults to last-material behaviour.
    isLastMaterial: PropTypes.bool,
    // Translation key for the button on the LAST material, instead of the default `start_exam`.
    // Employee login flow (Training.js) always has an exam after the materials and never passes
    // this — RegistrationStation.js (portiernia, no exam by design) passes `finish_training_title`.
    continueLabelKey: PropTypes.string
};

export default BaseCourseContent;
